// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"b927eaa9","498":"d58f22c0","703":"d243dfd6","787":"9f29a76c"}[chunkId] + ".chunk.js";
};